/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  FORGOT_PASSWORD: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.forgotPassword.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'FORGOT_PASSWORD' },
      },
    },
    FORGOT_PASSWORD: {
      invoke: {
        id: 'forgotPassword',
        src: 'forgotPassword',
        onDone: {
          target: 'FORGOT_PASSWORD_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'FORGOT_PASSWORD_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    FORGOT_PASSWORD_SUCCESS: {
      on: {
        START: { target: 'FORGOT_PASSWORD' },
      },
    },
    FORGOT_PASSWORD_FAILED: {
      on: {
        START: { target: 'FORGOT_PASSWORD' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
